/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import Constants from '../../Config/Config';
import $ from 'jquery';
import ReactPixel from 'react-facebook-pixel';
import {checkFramedSize} from '../../Helpers/Helpers';
import { Modal, Button } from 'react-bootstrap';

export default class CartForm extends Component {

	constructor(props) {
	    super(props);
		this.state = {
			buttonLoading: false,
			show: false,
        }
	    this.submitForm = this.submitForm.bind(this);
		this.handleShow = this.handleShow.bind(this);
    	this.handleClose = this.handleClose.bind(this);
    	this.handleOkay = this.handleOkay.bind(this);
  	}

	handleClose() {
		this.setState({ show: false });
	}

	handleShow() {
		this.setState({ show: true });
	}

	handleOkay() {
		this.handleClose();
		var glassID = 0;
		this.props.glasses.filter( ( glass ) =>
          	'Perspex Glass' === glass.getIn(['title', 'rendered'])
        ).map( ( glass ) =>
        	glassID = glass.get('id')
        )
        this.dispatchSelectGlass(glassID)
		this.submitForm(glassID);
	}

	dispatchSelectGlass(glassID) {
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				selectedGlass: glassID
			}
		})
  	}

  	submitForm = (glassID) => {
		  const {framedCalc, frameSizeW, frameSizeH, customizeQTY, cart1ItemTotal} = this.props;
			// console.log(cart1ItemTotal);

  		if (checkFramedSize(framedCalc, frameSizeW, frameSizeH, glassID)) {
	  		this.handleShow();
	  	} else {
			if (parseFloat(customizeQTY) > 0) {
	  			window.location.href = Constants.URL.root+"/cart/";
	  		} else {
	  			this.setState({buttonLoading: true});
	  			const ajaxurl = Constants.URL.root+'/wp-admin/admin-ajax.php';
	  			setTimeout(() => {
					$.ajax(ajaxurl, {
						method: "POST",
						dataType: 'json',
						data: $('.cartForm').serialize()+'&action=add_item_to_cart&cartTotal='+cart1ItemTotal,
						success: function (res) {
							window.location.href = Constants.URL.root+"/cart/";
							ReactPixel.track( 'AddToCart' );
						}
					});
				}, 1000);
	  		}
	  	}
  	}

	render() {
		const {selectedFrame, selectedTopMat, selectedMiddleMat, selectedBottomMat, selectedTopMatValueInCM, selectedMiddleMatValueInCM, selectedBottomMatValueInCM, topMatTotal, middleMatTotal, bottomMatTotal, frameTotal, glassTotal, selectedGlassName, backingTotal, selectedBackingName, printTotal, selectedPrintName, selectedMatSize, frameSizeH, frameSizeW, canvasThumbImage, frameImageHeight, frameImageWidth, frameImage, qty} = this.props;

		return (
			<form action={Constants.URL.root+"/cart/"} method="post" className="cartForm">

				<Modal
					show={this.state.show}
					onHide={this.handleClose}
				>
					<Modal.Header closeButton>
			        	<Modal.Title id="contained-modal-title-lg">Change Required</Modal.Title>
			        </Modal.Header>
					<Modal.Body>
						<p>Unfortunately the Picture Frame size you have selected requires you to select the Perspex Glass option. We highly recommend Perspex Glass for this Picture Frame size, as it is much lighter than Standard Glass and is much safer, as Perspex Glass will not break. If you have any questions please contact us today!</p>
					</Modal.Body>
					<Modal.Footer>
						<Button className="btn btn-primary btn-danger" onClick={this.handleClose}>Cancel</Button>
						<Button className="btn btn-primary btn-default" onClick={this.handleOkay}>That's OK</Button>
					</Modal.Footer>
				</Modal>

				<input type="hidden" name="quantity" value={qty} />
				<input type="hidden" name="frameTotal" value={frameTotal} />
				<input type="hidden" name="frameWidth" value={frameSizeW} />
				<input type="hidden" name="frameHeight" value={frameSizeH} />
				{selectedFrame.size > 0 &&
					<>
						<input type="hidden" name="item_id" value={selectedFrame.get('id')} />
						<input type="hidden" name="product_name" value={selectedFrame.get('name')} />
					</>
				}
				{frameImage !== null &&
					<input type="hidden" name="frameImageOriginal" value={frameImage} />
				}
				{canvasThumbImage !== null &&
					<input type="hidden" name="canvasImage" value={canvasThumbImage} />
				}
				{frameImageHeight !== 0 &&
					<input type="hidden" name="pictureHeight" value={frameImageHeight} />
				}
				{frameImageWidth !== 0 &&
					<input type="hidden" name="pictureWidth" value={frameImageWidth} />
				}
				{selectedTopMat.size > 0 && parseFloat(selectedMatSize) !== 0 &&
					<>
						<input type="hidden" name="tMatName" value={selectedTopMat.getIn(['title','rendered'])} />
						<input type="hidden" name="tMatTotal" value={topMatTotal} />
						<input type="hidden" name="tMatVal" value={selectedTopMatValueInCM} />
					</>
				}
				{selectedMiddleMat.size > 0 && (parseFloat(selectedMatSize) === 2 || parseFloat(selectedMatSize) === 3) &&
					<>
						<input type="hidden" name="mMatName" value={selectedMiddleMat.getIn(['title','rendered'])} />
						<input type="hidden" name="mMatTotal" value={middleMatTotal} />
						<input type="hidden" name="mMatVal" value={selectedMiddleMatValueInCM} />
					</>
				}
				{selectedBottomMat.size > 0 && parseFloat(selectedMatSize) === 3 &&
					<>
						<input type="hidden" name="bMatName" value={selectedBottomMat.getIn(['title','rendered'])} />
						<input type="hidden" name="bMatTotal" value={bottomMatTotal} />
						<input type="hidden" name="bMatVal" value={selectedBottomMatValueInCM} />
					</>
				}
				{selectedGlassName !== null &&
					<>
						<input type="hidden" name="glassName" value={selectedGlassName} />
						<input type="hidden" name="glassTotal" value={glassTotal} />
					</>
				}
				{selectedBackingName != null && selectedBackingName !== undefined &&
					<>
						<input type="hidden" name="backingName" value={selectedBackingName} />
						<input type="hidden" name="backingTotal" value={backingTotal} />
					</>
				}
				{selectedPrintName !== null &&
					<>
						<input type="hidden" name="printName" value={selectedPrintName} />
						<input type="hidden" name="printTotal" value={printTotal} />
					</>
				}
				<button type="button" className="btn btn-danger" onClick={this.submitForm.bind(this, this.props.selectedGlass)}>
					{this.state.buttonLoading ?
						<div className="loading"></div> :
						<span>{this.props.btnText}</span>
					}
				</button>
			</form>
	    );
	}
}